// Sourced namespace models
// NB This file is auto generated, do not manually alter!

  export enum CallOfCommitError {
    UnknownFault = 2,
    OK = 3,
    QuantityOverflow = 10,
    CustomerOrderNoAlreadyExists = 11,
  }

  /**
   * Information: Basic information that is to be seen as positive information, i.e. displayed with a green marker.
   * Normal: Aka "None".
   */
  export enum EventFlag {
    Normal = 'None',
    Information = 'Info',
    Warning = 'Warn',
    Error = 'Error',
    Returned = 'Return',
  }

  /**
   * Low: Matching [CommentStatus] "Information"
   * Medium: Matching [CommentStatus] "Warning"
   * High: Matching [CommentStatus] "High"
   * None: Severity is undefined for item, or set to 0.
   */
  export enum EventSeverity {
    Low = 'Low',
    Medium = 'Med',
    High = 'High',
    None = 'None',
  }

  export enum FlagType {
    Info = 1,
    Warning = 2,
    Error = 3,
    Normal = 4,
    Returned = 5,
  }

  export enum MBoxReferenceType {
    CustomerOrder = 0,
    WarehouseOrder = 1,
    Shipment = 2,
    ShipmentGroup = 3,
  }

  export enum MotionItemType {
    CustomerOrder = 'CO',
    WarehouseOrder = 'WO',
    Shipment = 'SH',
    ShipmentGroup = 'SG',
  }

  export enum NotificationCategory {
    All = 10,
    Carrier = 20,
    Contact = 30,
    System = 40,
    MyBoxes = 50,
    User = 60,
  }

  export enum StatusEventCategory {
    All = 1,
    Status = 2,
    Carrier = 3,
    MyBoxes = 4,
  }


  /**
   * It's actully also a limitation rule, again since no value set = all application views.
   */
  export enum UserAccessType {
    ApplicationView = 10,
    Country = 300,
    ZipZone = 301,
    Carrier = 302,
    ClientServiceGroup = 303,
    Dimension1 = 310,
    Dimension2 = 311,
    Dimension3 = 312,
  }

  export enum UserCategory {
    User = 1,
    SuperUser = 2,
    Agent = 3,
    Template = 4,
    ServiceUser = 5,
    Admin = 6,
    SystemUser = 7,
  }

  export enum UserKeyType {
    Domain = 0,
    Role = 1,
  }

  export enum UserRole {
    Unknown = 0,
    Admin = 1,
    SystemService = 2,
    SuperUser = 3,
    User = 4,
    Agent = 5,
  }

  export enum UserType {
    Template = 1,
    OurBoxesSettings = 10,
    OurBoxes = 11,
    Report = 30,
    AutoSender = 35,
    ApiAddBoxes = 80,
    ApiYourBoxes = 90,
    UserActionGroup = 110,
    Customer = 1000,
    System = 2000,
  }

  /**
   * S: ShipmentID
   * R: ReferenceNo
   * I: ClientReferenceNo
   * C: Customer information, i.e. from Recipient name, address, email etc.
   * U: Unknown
   * P: Hit on explicit ParcelID given
   */
  export enum WordAreaType {
    S = 'ShipmentID',
    R = 'ReferenceNo',
    I = 'ClientReferenceNo',
    C = 'CustomerInformation',
    U = 'Unknown',
    P = 'ParcelID',
  }

